export default {
  wrapper: {
    // display: 'flex',
  },

  statusFactoid: {
    flexGrow: 1,
  },

  initialFact: {
    marginRight: 56,
  },
  facts: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },

  fact: {
    flexBasis: '33.3%',
    marginBottom: 18,
  },
};
